import type { CSSProperties } from 'react';
import BiDirectionalArrowsIconSvg from '../../assets/icons/bi_directional_arrows.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const BiDirectionalArrowsIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <BiDirectionalArrowsIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default BiDirectionalArrowsIcon;
